<template>
	<div class="app-container">
		<div class="head-container">
			<!-- 搜索区域 -->
			<!-- <IssueReceiptTypeSearchform @searchForm="searchFormHandler"></IssueReceiptTypeSearchform> -->
			<div>
				<!-- 功能按钮 -->
				<Button
					@showDialogAdd="showDialogAddHandler"
					@showDialogEdit="showDialogEditHandler"
					@showDelete="showDeleteHandler"
					:selectData_p="selectData"
					:delTips_p="delTips"
					:authorize_p="'issueReceiptType'"
					:editDisabled_p="editDisabled"
				></Button>
			</div>
		</div>
		<!--表格渲染-->
		<Table ref="tableDom" :data.sync="tableData" :tableColumn_p="tableColumn" :selectData_p.sync="selectData">
			<el-table-column label="出入库类型">
				<template slot-scope="scope">
					{{ scope.row.inOutType === 1 ? '入库' : '出库' }}
				</template>
			</el-table-column>
			<el-table-column label="启用/禁用">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.enable" @change="enableHandler(scope.row)" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="left" fixed="right" width="300">
				<template slot-scope="scope">
					<el-button
						id="btn-update-row"
						type="primary"
						v-authorize="{ name: 'update', type: 'issueReceiptType', id: 'btn-update-row' }"
						@click="editSingleHandler(scope.row)"
					>
						编辑
					</el-button>
					<el-button
						id="btn-remove-row"
						type="danger"
						v-authorize="{ name: 'remove', type: 'issueReceiptType', id: 'btn-remove-row' }"
						@click="deleteSingleHandler(scope.row)"
					>
						删除
					</el-button>
				</template>
			</el-table-column>
		</Table>
		<!-- <Pagination :total="total" :pageIndex_p.sync="pageIndex" :pageSize_p.sync="pageSize"></Pagination> -->
		<Dialog :title="dialogTitle" :visible.sync="isShowAEDialog">
			<IssueReceiptTypeAddForm
				v-if="isShowAEDialog"
				:isShowAEDialog_p.sync="isShowAEDialog"
				:isRefreshList_p.sync="isRefreshList"
				:selectData_p="selectData"
				:editId_p="editId"
			></IssueReceiptTypeAddForm>
		</Dialog>
	</div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import {
	measureUnitDeleteService,
	issueReceiptTypeListService,
	issueReceiptTypeEditService,
	issueReceiptTypeDetailService
} from '@s/base/IssueReceiptTypeService';

import IssueReceiptTypeAddForm from '@f/base/issueReceipt/IssueReceiptTypeAdd.form';
/* import IssueReceiptTypeSearchform from '@f/base/issueReceipt/IssueReceiptTypeSearch.form'; */

import Button from '@c/ui/Button';
import Table from '@c/ui/Table';
/* import Pagination from '@c/ui/Pagination'; */
import Dialog from '@c/ui/Dialog';
import ListMixin from '@m/List.mixin';

export default {
	mixins: [ListMixin],
	components: {
		Button,
		Table,
		/* Pagination, */
		Dialog,
		/* IssueReceiptTypeSearchform, */
		IssueReceiptTypeAddForm
	},
	data() {
		return {
			// 表格
			tableColumn: [
				{
					label: '序号',
					field: 'id'
				},
				{
					label: '类型名称',
					field: 'name'
				}
			],
			delTips: '',
			isShowConfigDialog: false,
			editDisabled: true
		};
	},
	computed: {
		dialogTitle() {
			return this.editId === -1 ? '新增出入库类型' : '编辑出入库类型';
		}
	},
	watch: {
		pageIndex(newValue) {
			this.pageIndex = newValue;
			this.issueReceiptTypeList();
		},
		pageSize(newValue) {
			this.pageSize = newValue;
			this.issueReceiptTypeList();
		},
		isRefreshList(newValue) {
			if (newValue) {
				this.issueReceiptTypeList();
			}
		}
	},
	mounted() {
		this.issueReceiptTypeList();
	},
	methods: {
		async issueReceiptTypeList() {
			const dataJson = {
				...this.searchForm
			};
			const res = await issueReceiptTypeListService(dataJson);
			this.listMixin(res);
		},
		showDialogAddHandler() {
			this.dialogAddHandlerMixin();
		},
		async showDialogEditHandler() {
			const editId = this.dialogEditHandlerMixin();
			const dataJson = {
				id: editId
			};
			const res = await issueReceiptTypeDetailService(dataJson);
			this.selectData = [res];
			this.isShowAEDialog = true;
		},
		async showDeleteHandler() {
			const ids = this.filterSelectIdsMixin();
			const dataJson = {
				id: ids
			};
			await measureUnitDeleteService(dataJson);
			this.isRefreshList = true;
		},
		async editSingleHandler(row) {
			const dataJson = {
				id: row.id
			};
			const res = await issueReceiptTypeDetailService(dataJson);
			this.editSingleHandlerMixin(res);
		},
		deleteSingleHandler(row) {
			this.deleteSingleHandlerMixin(row);
		},
		searchFormHandler(searchForm) {
			this.searchFormHandlerMixin(searchForm);
			this.issueReceiptTypeList();
		},
		async enableHandler(row) {
			const dataJson = {
				...row
			};
			await issueReceiptTypeEditService(dataJson);
            this.issueReceiptTypeList();
		}
	}
};
</script>

<style lang="less" scoped>
.orglist {
	height: 400px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
</style>
